/**
 * @file NotEnoughData.js
 * @description Card that is used when the API returns no data or empty data for any given dashboard card.
 */

import React from 'react';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { useTheme } from '../../store/ThemeContext';
import './NotEnoughData.scss';
import { getText } from '../../i18n';

const NotEnoughData = () => {
    const themeStyles = useTheme();
    return (
        <div className="not-enough-data">
            <ShowChartIcon
                className="not-enough-data-icon"
                style={{ color: themeStyles?.accessoriesBg1 || '#1366FF' }}
            />
            <div className="not-enough-data-text">{getText('msg_e42c0c2d9383')}</div>
            <div className="not-enough-data-text-suggestion">
                {getText('msg_87de30b7e126')}
            </div>
        </div>
    );
};

export default NotEnoughData;
